<template>
  <div class="index">
    <!-- 筛选 -->
    <!-- <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="企业名称：">
            <el-input clearable v-model="filterForm.o_name" placeholder="请输入企业名称"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section> -->
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <!-- <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button> -->
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">关联</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="createContractHandler(scope.row.o_name)" v-if="btnShow.create_hetong">发起合同</el-button>
            <el-button size="mini" plain type="success" @click="viewContractListHandler(scope.row.o_name)" v-if="btnShow.search_hetong">查看合同</el-button>
            <!-- <el-button size="mini" plain type="success" @click="modifyHandler(scope.row)">编辑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 发起合同 -->
    <el-dialog
      title="合同信息" :modal="false" width="1000px" center
      :visible.sync="centerDialogVisible_contract_create"
      :close-on-click-modal="false" @close="dialogClose_contract_create">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">合同详情</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form :rules="rules" label-width="210px" ref="editForm_contract_create" size="mini" :model="editForm_contract_create">
                    <!-- <el-form-item label="地区">
                      <AreaPicker ref="AreaPicker_form" @getData="filterHandler" />
                    </el-form-item> -->
                    <el-form-item prop="o_name" label="单位名称">
                      <el-input clearable v-model="editForm_contract_create.o_name" style="width:400px;" disabled></el-input>
                    </el-form-item>
                    <el-form-item prop="contractName" label="合同名称">
                      <el-input clearable v-model="editForm_contract_create.contractName" style="width:400px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="contractType" label="合同类型">
                      <el-select clearable filterable size="mini" style="width:400px;" v-model="editForm_contract_create.contractType">
                        <el-option v-for="(x, i) in ['劳务派遣','业务外包','劳动事务代理','个人业务','其他业务']" :key="i" :label="x" :value="x"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="startDate" label="合作开始时间">
                      <!-- <el-input clearable v-model="editForm_contract_create.startMillisecond" style="width:400px;"></el-input> -->
                      <el-input clearable v-model="editForm_contract_create.startDate" style="width:400px;" placeholder="格式为yyyymmdd，8位数字"></el-input>
                    </el-form-item>
                    <el-form-item prop="endDate" label="合作结束时间">
                      <!-- <el-input clearable v-model="editForm_contract_create.endMillisecond" style="width:400px;"></el-input> -->
                      <el-input clearable v-model="editForm_contract_create.endDate" style="width:400px;" placeholder="格式为yyyymmdd，8位数字"></el-input>
                    </el-form-item>
                    <el-form-item prop="protocolStartDate" label="协议执行开始时间">
                      <!-- <el-input clearable v-model="editForm_contract_create.protocolStartMillisecond" style="width:400px;"></el-input> -->
                      <el-input clearable v-model="editForm_contract_create.protocolStartDate" style="width:400px;" placeholder="格式为yyyymmdd，8位数字"></el-input>
                    </el-form-item>
                    <el-form-item prop="protocolEndDate" label="协议执行结束时间">
                      <!-- <el-input clearable v-model="editForm_contract_create.protocolEndMillisecond" style="width:400px;"></el-input> -->
                      <el-input clearable v-model="editForm_contract_create.protocolEndDate" style="width:400px;" placeholder="格式为yyyymmdd，8位数字"></el-input>
                    </el-form-item>
                    <el-form-item prop="remarks" label="备注">
                      <el-input clearable v-model="editForm_contract_create.remarks" style="width:400px;"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose_contract_create()">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit_contract_create()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 模态框 查看合同 -->
    <el-dialog
      title="合同列表" :modal="false" width="1400px" center
      :visible.sync="centerDialogVisible_contract_view"
      :close-on-click-modal="false" @close="dialogClose_contract_view">
      <el-table :data="tableData_contract" max-height="550" border @selection-change="(val)=>{selectRow=val}">
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo_contract" :key="i"
          :prop="x.key" :label="x.label" align="center"></el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="primary" @click="viewContractDetailHandler(scope.row.id)" v-if="btnShow.modify_hetong">编辑</el-button>
            <el-button size="mini" plain type="danger" @click="deleteContractHandler(scope.row.id)" v-if="btnShow.modify_hetong">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <paging :pagesData="pageData_contract" @set_page_number="pageNumberChange_contract"></paging>
    </el-dialog>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems_"
      :formItems2="formItems2"
      dialogWidth="1000px" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :rules="rules"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler"
      dialogWidth="1000px" />
      <!-- @watchChange="watchChange"
      :isShowArea="true" -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" />
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'rlzy_guanlian_qiye',
      dialogTitle: '关联企业信息',
      // fileName: 'qiyexinxi',
      xlsCode: '57',
      importTipKey: 'o_name',
      importTiplabel: '企业名称',

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },
        // { key: 'areaName', label: '地区' },

        { key: 'o_name', label: '企业名称' },
        { key: 'o_socialCode', label: '企业信用代码' },
        { key: 'o_type', label: '公司性质' },
        { key: 'o_domain', label: '所属行业' },
        { key: 'o_phone', label: '企业电话' },
        { key: 'o_fax', label: '企业传真' },
        // { key: 'o_QQ', label: '企业QQ' },
        // { key: 'o_weixin', label: '企业微信' },
        { key: 'o_gift', label: '是否发放生日礼金' },
      ],
      // watchChangeKey: ['buyType'],
      // defaultKeyValue: {
      //   buyType: 1
      // },
      userList: [],

      isShowDetail: false,

      
      centerDialogVisible_contract_create: false,
      editForm_contract_create: {},
      editForm_contract_create_ori: {},

      centerDialogVisible_contract_view: false,
      editForm_contract_view: {},
      tableData_contract: [],
      baseInfo_contract: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },

        { key: 'o_name', label: '单位名称' },
        { key: 'contractName', label: '合同名称' },
        { key: 'contractType', label: '合同类型' },
        { key: 'startDate', label: '合作开始时间' },
        { key: 'endDate', label: '合作结束时间' },
        { key: 'protocolStartDate', label: '协议执行开始时间' },
        { key: 'protocolEndDate', label: '协议执行结束时间' },
        { key: 'remarks', label: '备注' },
      ],
      rules: {
        o_id: [{ required: true, message: '必填', trigger: 'change' }],
        o_name: [{ required: true, message: '必填', trigger: 'change' }],
        contractName: [{ required: true, message: '必填', trigger: 'change' }],
        startDate: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
        endDate: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
        protocolStartDate: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
        protocolEndDate: [{ trigger: 'blur', validator: this.$t.validator_number_8 }],
      },

      pageData_contract: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },
    }
  },
  computed: {
    importAction() {
      // return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
      return this.$api.baseUrl + this.$api.url_import(this.sign)
    },
    formItems() {
      console.log(this.isCreate)
      if (this.isCreate) {
        return [
          { type: 'select_s', key: 'o_id', label: '企业名称', options: this.userList, remoteMethod: this.getUesrData, isWatch: true },
          // { type: 'text', key: 'u_nickName', label: '对象姓名' },
        ]
      } else {
        return [
          { type: 'text', key: 'o_name', label: '企业名称', disabled: true },
          // { type: 'select_s', key: 'o_domain', label: '所属行业', options: this.$fuwuData.suoshuhangye3g },
          // { type: 'select_s', key: 'o_type', label: '企业性质', options: this.$fuwuData.companyType },
          // { type: 'date', key: 'o_publicTime', label: '成立时间' },
          // { type: 'text', key: 'o_registerCash', label: '注册资金' },
          // { type: 'text', key: 'o_person', label: '员工人数' },
          // { type: 'text', key: 'o_phone', label: '企业电话' },
          // { type: 'text', key: 'o_fax', label: '企业传真' },
          // { type: 'text', key: 'o_QQ', label: '企业QQ' },
          // { type: 'text', key: 'o_weixin', label: '企业微信' },
          // { type: 'image', key: 'o_homeUrl', label: '企业logo', size: '120px*120px', limitNum: 1, index: 1 },
          // { type: 'image', key: 'o_signatureUrl', label: '电子签名', size: '无', limitNum: 1, index: 2 },
          // { type: 'text', key: 'o_socialCode', label: '企业信用代码' },
          // { type: 'text', key: 'o_address', label: '企业地址' },
          // { type: 'text', key: 'o_description', label: '企业简介' },
          // { type: 'video', key: 'o_videoUrl', label: '视频简介', index: 3 },
          { type: 'text', key: 'o_socialCode', label: '统一信用代码' },
          { type: 'select_s', key: 'o_type', label: '单位类型', options: this.$fuwuData.companyType },
          { type: 'select_s', key: 'o_domain', label: '所属行业', options: this.$fuwuData.suoshuhangye3g },
          { type: 'text', key: 'o_leader', label: '法定代表人' },
          { type: 'text', key: 'o_dealPerson', label: '单位经办人' },
          { type: 'text', key: 'o_dealPersonPhone', label: '经办人电话' },
          { type: 'text', key: 'o_address', label: '单位地址' },
          { type: 'text', key: 'o_phone', label: '单位电话' },
          { type: 'text', key: 'o_fax', label: '单位传真' },
          { type: 'text', key: 'o_gift', label: '是否发放生日礼金' },
          { type: 'text', key: 'o_remarks', label: '备注' },
        ]
      }
    },
    formItems_() {
      return [
          { type: 'text', key: 'o_name', label: '企业名称' },
          // { type: 'select_s', key: 'o_domain', label: '所属行业' },
          // { type: 'select_s', key: 'o_type', label: '企业性质' },
          // { type: 'date', key: 'o_publicTime', label: '成立时间' },
          // { type: 'text', key: 'o_registerCash', label: '注册资金' },
          // { type: 'text', key: 'o_person', label: '员工人数' },
          // { type: 'text', key: 'o_phone', label: '企业电话' },
          // { type: 'text', key: 'o_fax', label: '企业传真' },
          // { type: 'text', key: 'o_QQ', label: '企业QQ' },
          // { type: 'text', key: 'o_weixin', label: '企业微信' },
          // { type: 'image', key: 'o_homeUrl', label: '企业logo', index: 1 },
          // { type: 'image', key: 'o_signatureUrl', label: '电子签名', index: 2 },
          // { type: 'text', key: 'o_socialCode', label: '企业信用代码' },
          // { type: 'text', key: 'o_address', label: '企业地址' },
          // { type: 'text', key: 'o_description', label: '企业简介' },
          // { type: 'video', key: 'o_videoUrl', label: '视频简介', index: 3 },
          { type: 'text', key: 'o_socialCode', label: '统一信用代码' },
          { type: 'select_s', key: 'o_type', label: '单位类型', options: this.$fuwuData.companyType },
          { type: 'select_s', key: 'o_domain', label: '所属行业', options: this.$fuwuData.suoshuhangye3g },
          { type: 'text', key: 'o_leader', label: '法定代表人' },
          { type: 'text', key: 'o_dealPerson', label: '单位经办人' },
          { type: 'text', key: 'o_dealPersonPhone', label: '经办人电话' },
          { type: 'text', key: 'o_address', label: '单位地址' },
          { type: 'text', key: 'o_phone', label: '单位电话' },
          { type: 'text', key: 'o_fax', label: '单位传真' },
          { type: 'text', key: 'o_remarks', label: '备注' },
      ]
    },
    formItems2() {
      return null
    }
  },
  methods: {
    // ——————————————————————————————————————————————————————————————————————
    // 发起合同
    createContractHandler(o_name) {
      console.log(`%c企业ID:`, 'color: #00f;', o_name)      
      this.centerDialogVisible_contract_create = true
      this.editForm_contract_create.o_name = o_name
    },
    // 发起合同 关闭
    dialogClose_contract_create() {
      this.centerDialogVisible_contract_create = false
      this.editForm_contract_create = {}
    },
    // 发起合同 提交
    dialogSubmit_contract_create() {
      this.$refs['editForm_contract_create'].validate((valid) => {
        if (valid) {
          let rD = {}

          // // let areaId = this.$refs.AreaPicker_form.findAreaId()
          // let areaNames = this.$refs.AreaPicker_form.findAreaNames()
          // // console.log(`%c123:`, 'color: #f00;', areaId, areaNames)
          // const areaMap = [
          //   'province',
          //   'city',
          //   'county',
          //   'town',
          //   'village',
          // ]
          // areaMap.forEach((x, i) => {
          //   rD[x] = areaNames[i]
          // })
          // console.log(`%crD:`, 'color: #00f;', rD)

          // if (!rD.province) { this.$message.warning('请选择地区') }
          // else 
          let {
            o_name,
            contractName
          } = this.editForm_contract_create
          if ((this.editForm_contract_create.id)) {
            
            const mapList = [
              'contractName',
              'contractType',
              'startDate',
              'endDate',
              'protocolStartDate',
              'protocolEndDate',
              'remarks',
            ]
            mapList.forEach(x => {
              if (this.editForm_contract_create[x] !== this.editForm_contract_create_ori[x]) {
                rD[x] = this.editForm_contract_create[x]
              }
            })
            rD.id = this.editForm_contract_create.id

            this.$api.util_modify('rlzy_guanlian_hetong', rD).then(res => {
              if (res.data.status == 0) {
                this.$message.success('修改成功！')
                this.viewContractListHandler()
              } else { this._status(res.data) }
            })
          } else {
            Object.assign(rD, this.editForm_contract_create)
            console.log(`%crD:`, 'color: #00f;', rD)
            this.$api.util_create('rlzy_guanlian_hetong', rD).then(res => {
              if (res.data.status == 0) {
                this.$message.success('发起成功！')
              } else { this._status(res.data) }
            })
          }
        } else { return }
      })
    },
    // ——————————————————————————————————————————————————————————————————————
    // 查看合同列表
    viewContractListHandler(o_name = this.editForm_contract_view.o_name) {
      console.log(`%c企业ID:`, 'color: #00f;', o_name)
      this.centerDialogVisible_contract_view = true
      this.editForm_contract_view.o_name = o_name
      let rD = {
        o_name,
        pageNumber: this.pageData_contract.currentPage,
      }
      this.$api.util_search('rlzy_guanlian_hetong', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c合同列表:`, 'color: #f00;', _R)
          this.tableData_contract = _R.map(x => {
            x.okText = x.ok ? '已签约' : '未签约'
            return x
          })
          this.pageData_contract.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    // 查看合同 关闭
    dialogClose_contract_view() {
      this.centerDialogVisible_contract_view = false
      this.editForm_contract_view = {}
    },
    // 查看合同 页码
    pageNumberChange_contract(pageNumer) {
      this.pageData_contract.currentPage = pageNumer
      this.viewContractHandler()
    },
    // 查看合同 详情
    viewContractDetailHandler(id) {
      this.centerDialogVisible_contract_create = true
      let rD = { id }
      this.$api.util_search('rlzy_guanlian_hetong', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c合同详情:`, 'color: #f00;', _R[0])
          this.editForm_contract_create = _R[0]
          this.editForm_contract_create_ori = JSON.parse(JSON.stringify(_R[0]))
        } else { this._status(res.data) }
      })
    },
    // 查看合同 删除
    deleteContractHandler(id) {
      this.$confirm('确认删除数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let rD = {
          ids: [id]
        }
        this.$api.util_delete('rlzy_guanlian_hetong', rD).then(res => {
          if (res.data.status === 0 ) {
            this.$message.success('删除成功！')
            // —————————————————— 把当前页的所有数据都删除时，需要更换页码 s ——————————————————
            let nowtotal = this.pageData_contract.total - rD.ids.length
            if (nowtotal % this.pageData_contract.pageSize === 0) {
              if (this.pageData_contract.currentPage > 1) {
                this.pageData_contract.currentPage--
              } else {
                this.pageData_contract.currentPage = 1
              }
            }
            // —————————————————— 把当前页的所有数据都删除时，需要更换页码 e ——————————————————
            console.log('删除后总条数',nowtotal,'当前页数',this.pageData_contract.currentPage)
            this.viewContractListHandler()
          } else { this._status(res.data) }
        })
      }).catch(() => {})
    },
    // ——————————————————————————————————————————————————————————————————————
    searchHandler() {
      let rD = this.beforeSearchAndExportHandler(this.filterForm)
      rD.pageNumber = this.pageData.currentPage
      // console.log(rD)
      this.getData(rD)
    },
    // modifyHandlerBefore() {
    //   let {
    //     oUser
    //   } = this.selectData
    //   console.log(oUser.o_name)
    //   this.userList = [
    //     {
    //       label: oUser.o_name,
    //       value: oUser.id,
    //     }
    //   ]
    // },
    // watchChange(data) {
    //   console.log(`%caaaa:`, 'color: #f00;', data.val)
    //   if (data.val === 1) {
    //     this.formItems.splice(8, 1)
    //   } else if (data.val === 2) {
    //     this.formItems.splice(8, 1, { type: 'text', key: 'cash', label: '垫付金额' })
    //   }
    // },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let rData = {}
      let {
        // id, province, city, county, town, village, 
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        o_id,
        // o_domain,
        // o_type,
        // o_publicTime,
        // o_registerCash,
        // o_person,
        // o_phone,
        // o_fax,
        // o_QQ,
        // o_weixin,
        // o_homeUrl,
        // o_signatureUrl,
        // o_socialCode,
        // o_address,
        // o_description,
        // o_videoUrl,
        o_socialCode,
        o_type,
        o_domain,
        o_leader,
        o_dealPerson,
        o_dealPersonPhone,
        o_address,
        o_phone,
        o_fax,
        o_remarks,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      } = result
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (this.isCreate) {
        rData = {
          // province, city, county, town, village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          o_id,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        }
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        rData.userId = this.userInfo.id
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        // const mapList_must = ['province', 'city', 'county', 'town', 'village']
        // mapList_must.forEach(x => {
        //   rData[x] = result[x]
        // })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList = [
          // 'o_domain',
          // 'o_type',
          // 'o_publicTime',
          // 'o_registerCash',
          // 'o_person',
          // 'o_phone',
          // 'o_fax',
          // 'o_QQ',
          // 'o_weixin',
          // 'o_homeUrl',
          // 'o_signatureUrl',
          // 'o_socialCode',
          // 'o_address',
          // 'o_description',
          // 'o_videoUrl',
          'o_socialCode',
          'o_type',
          'o_domain',
          'o_leader',
          'o_dealPerson',
          'o_dealPersonPhone',
          'o_address',
          'o_phone',
          'o_fax',
          'o_remarks',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.o_id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api._user_modify(rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      rD.userId = this.userInfo.id
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          // this.tableData = _R
          this.tableData = _R.map(x => {
            let obj = JSON.parse(JSON.stringify((x.oUser)))
            obj.id = x.id
            obj.userId = x.userId
            obj.o_id = x.o_id
            return obj
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    getUesrData(val) {
      console.log(val, this.areaIds_x)
      let rD = {
        // areaId: this.areaIds_x[this.areaIds_x.length - 1],
        o_name: val,
        organization: true,
      }
      // console.log(rD)
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.userList = _R.map(x => {
            return {
              label: x.o_name,
              value: x.id,
            }
          })

          // 如果对话框里有切换的项目，修改前要先切换到对应的项目
          if(this.watchChangeKey) {
            let eData = this.$refs.DialogEdit.eData
            console.log(`%ceData:`, 'color: #f00;', eData)
            this.watchChangeKey.forEach(x => {
              this.watchChange({ key: x, val: eData[x] })
            })
          }
          console.log(`%c用户数据:`, 'color: #00f;', this.userList)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    const powerStr = powerMap[this.sign]
    // const powerStr = powerMap[this.catalog]
    // console.log(powerStr)
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    const mapList = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    if (powerList.includes(powerStr + '-create')) {
      this.btnShow.modify = true
    }
    const mapList_hetong = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList_hetong.forEach(x => {
        this.btnShow[x + '_hetong'] = true
      })
    } else {
      mapList_hetong.forEach(x => {
        if (x && powerList.includes(powerMap['rlzy_guanlian_hetong'] + '-' + x)) {
          this.btnShow[x + '_hetong'] = true
          this.btnShow.search_hetong = true
        }
      })
    }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    this.filterHandler()
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>